import { useNavigate } from "react-router-dom";
import { TextField, Button, IconButton, InputAdornment } from "@mui/material";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import React, { useState } from "react";
import * as Yup from 'yup';
import { useFormik } from "formik";
import { usePostChangePasswordMutation } from "../../services/auth";
import { showError, showToast } from "../../helpers";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [changePassword, { isLoading }] = usePostChangePasswordMutation();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [oldPassword, setOldPassword] = useState<boolean>(false);
  const [cnfmPassword, setCnfmPassword] = useState<boolean>(false);
  
  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const [showPassword1, setShowPassword1] = React.useState(false);
  const handleClickShowPassword1 = () => {
    setShowPassword1((prev) => !prev);
  };
  const handleMouseDownPassword1 = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const [showPassword2, setShowPassword2] = React.useState(false);
  const handleClickShowPassword2 = () => {
    setShowPassword2((prev) => !prev);
  };
  const handleMouseDownPassword2 = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

    const formik = useFormik({
    initialValues: {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string()
        // .min(6,"Minimum 6 character are required")
        .required('Current password is required'),
      newPassword: Yup.string()
        .required('New password is required')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/,
          'Password must be at least 8 characters long and include 1 uppercase, 1 lowercase, and 1 special character.',
        )
        .notOneOf([Yup.ref('oldPassword'), null], "New password can't be same as old password"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword')], 'Passwords should match')
        .required('Confirm password is required'),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);
      const body = {
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
      };
      try {
        const response = await changePassword(body as any).unwrap();
        if (response?.statusCode === 200) {
          showToast('Password changed successfully');
          navigate('/dashboard');
        }
      } catch (error: any) {
        console.log(error);
        showError(error?.data?.message || '');
      }
      formik.setSubmitting(false);
    },
  });

  return (
    <>
      <div className="main_title">
        <h1>Change Password</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {' '} - <button onClick={() => navigate("/manage-profile")}>Manage Profile</button>
          {' '} - Change Password
        </p>
      </div>

      <div className="cards">
        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="gap_p">
         <div className="control_group w_33">
              <label htmlFor="password">Old Password</label>
             <TextField
            className="text_field"
            hiddenLabel
            placeholder="Old Password"
            fullWidth
            id="oldPassword"
            name="oldPassword"
            type={oldPassword ? 'text' : 'password'}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.oldPassword}
            helperText={formik.touched.oldPassword && formik.errors.oldPassword}
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" className="eye_btn">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setOldPassword(!oldPassword)}
                    onMouseDown={(event) => event.preventDefault()}
                    edge="end"
                  >
                    {oldPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
            </div>
            <div className="control_group w_33">
              <label htmlFor="newpassword">New Password</label>
             <TextField
            className="text_field"
            placeholder="New Password"
            fullWidth
            id="newPassword"
            name="newPassword"
            type={cnfmPassword ? 'text' : 'password'}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.newPassword}
            helperText={formik.touched.newPassword && formik.errors.newPassword}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" className="eye_btn">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setCnfmPassword(!cnfmPassword)}
                    onMouseDown={(event) => event.preventDefault()}
                    edge="end"
                  >
                    {cnfmPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
            </div>
            <div className="control_group w_33">
              <label htmlFor="confirmpassword">Confirm New Password</label>
         <TextField
            className="text_field"
            placeholder="Confirm Password"
            fullWidth
            id="confirmPassword"
            name="confirmPassword"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.confirmPassword}
            helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
            type={showPassword ? 'text' : 'password'}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" className="eye_btn">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={(event) => event.preventDefault()}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
            </div>
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary"
            type="submit"
            disabled={isLoading}
            >
              Save</Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ChangePassword;
